import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a5cf86b4")

_pushScopeId("data-v-a5cf86b4")
const _hoisted_1 = { class: "reportConfirm_reportItem" }
const _hoisted_2 = { class: "reportConfirm_reportItem_show" }
const _hoisted_3 = { class: "reportConfirm_reportItem_show_itemMsg" }
const _hoisted_4 = { class: "filedName" }
const _hoisted_5 = { class: "filedValue" }
const _hoisted_6 = {
  key: 0,
  class: "reportConfirm_reportItem_show_itemNum"
}
const _hoisted_7 = { class: "reportConfirm_reportItem_box reportConfirm_reportItem_hide" }
const _hoisted_8 = {
  key: 0,
  class: "reportConfirm_reportItem_detect"
}
const _hoisted_9 = { class: "reportConfirm_reportItem_detectNum" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("贴膜 ")
const _hoisted_11 = {
  key: 1,
  class: "reportConfirm_reportItem_detect"
}
const _hoisted_12 = { class: "reportConfirm_reportItem_detectNum" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("重做漆 ")
const _hoisted_14 = {
  key: 2,
  class: "reportConfirm_reportItem_detect"
}
const _hoisted_15 = { class: "reportConfirm_reportItem_detectNum" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("钣金修复 ")
const _hoisted_17 = {
  key: 3,
  class: "reportConfirm_reportItem_detect"
}
const _hoisted_18 = { class: "reportConfirm_reportItem_detectNum green" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("漆膜正常 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_reportComfirmTitle = _resolveComponent("reportComfirmTitle")
  const _component_van_icon = _resolveComponent("van-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_reportComfirmTitle, {
      titleTxt: "漆膜信息",
      isShowRight: true,
      goPageType: "qimojiance"
    }),
    _withDirectives(_createVNode("img", {
      class: "reportConfirm_reportItem_paintImg",
      src: _ctx.renderData.photoUrl,
      alt: ""
    }, null, 8, ["src"]), [
      [_vShow, _ctx.state.isShowMore]
    ]),
    _withDirectives(_createVNode("ul", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.renderData.itemList, (item) => {
        return (_openBlock(), _createBlock("li", {
          class: "reportConfirm_reportItem_show_item",
          key: item.itemCode
        }, [
          _createVNode("p", _hoisted_3, [
            _createVNode("span", _hoisted_4, _toDisplayString(item.itemName), 1),
            _createVNode("b", _hoisted_5, [
              _createVNode("span", null, _toDisplayString(item.tip), 1)
            ])
          ]),
          (item.itemDesc)
            ? (_openBlock(), _createBlock("p", _hoisted_6, _toDisplayString(item.itemDesc), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 512), [
      [_vShow, _ctx.state.isShowMore]
    ]),
    _createVNode("div", _hoisted_7, [
      (_ctx.renderData.fullPaintCount>0)
        ? (_openBlock(), _createBlock("span", _hoisted_8, [
            _createVNode("b", _hoisted_9, _toDisplayString(_ctx.renderData.fullPaintCount), 1),
            _hoisted_10
          ]))
        : _createCommentVNode("", true),
      (_ctx.renderData.repair>0)
        ? (_openBlock(), _createBlock("span", _hoisted_11, [
            _createVNode("b", _hoisted_12, _toDisplayString(_ctx.renderData.repair), 1),
            _hoisted_13
          ]))
        : _createCommentVNode("", true),
      (_ctx.renderData.bjCount>0)
        ? (_openBlock(), _createBlock("span", _hoisted_14, [
            _createVNode("b", _hoisted_15, _toDisplayString(_ctx.renderData.bjCount), 1),
            _hoisted_16
          ]))
        : _createCommentVNode("", true),
      (_ctx.renderData.count>0)
        ? (_openBlock(), _createBlock("span", _hoisted_17, [
            _createVNode("b", _hoisted_18, _toDisplayString(_ctx.renderData.count), 1),
            _hoisted_19
          ]))
        : _createCommentVNode("", true),
      _createVNode("span", {
        class: "reportConfirm_lookMore",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showOrHide && _ctx.showOrHide(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.state.isShowMore ? '收起' : '展开') + " ", 1),
        _withDirectives(_createVNode(_component_van_icon, { name: "arrow-down" }, null, 512), [
          [_vShow, !_ctx.state.isShowMore]
        ]),
        _withDirectives(_createVNode(_component_van_icon, { name: "arrow-up" }, null, 512), [
          [_vShow, _ctx.state.isShowMore]
        ])
      ])
    ])
  ]))
})